import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axiosInstance from './services/axios';

Vue.config.productionTip = false
Vue.prototype.$axios = axiosInstance;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
